import script from "./ResultList.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultList.vue?vue&type=script&setup=true&lang=js"

export default script